module.exports = __webpack_public_path__ + "img/11.0daec509.png";